module.exports = __webpack_public_path__ + "img/cert_bg.bfea56b3.jpg";